import axios from '../axios'

const state = {
    sessionid: localStorage.getItem("sessionid") || "",
	site: localStorage.getItem("site") || "",
    status: ""
};

const getters = {
    isAuthenticated: state => !!state.sessionid,
    authStatus: state => state.status,
	sessionid: state => state.sessionid,
	site: state => state.site
};

const actions = {
    authRequest: ({ commit, dispatch }, req) => {
        return new Promise((resolve, reject) => {
            commit('auth_request');
            axios.post("https://new.colorwayrb.com/backend/login.php", req)
                .then(({ data }) => {
                    localStorage.setItem("sessionid", data.sessionid);
					localStorage.setItem("site", data.site);
                    // Here set the header of your ajax library to the token value.
                    // example with axios
					if (data.msg == "OK") {
						axios.defaults.headers.common['Authorization'] = data.sessionid
						commit('auth_success', data);
						resolve(data);
					} else {
						commit('auth_error');
						localStorage.removeItem("sessionid");
						localStorage.removeItem("site");
						//reject();
					}
                })
                .catch((err) => {
                    commit('auth_error');
                    localStorage.removeItem("sessionid");
					localStorage.removeItem("site");
                    reject(err);
                });
        });
    },
    authLogout: ({ commit }) => {
        return new Promise(resolve => {
			axios.get("https://new.colorwayrb.com/backend/logout.php")
			.then(({ data }) => {
				
			});
			commit('auth_logout');
				localStorage.removeItem("sessionid");
				localStorage.removeItem("site");
				resolve();
            
        });
    }
};

const mutations = {
    auth_request: state => {
        state.status = "loading";
    },
    auth_success: (state, payload) => {
        state.sessionid = payload.sessionid;
        state.status = payload.msg;
		state.site = payload.site;
    },
    auth_error: state => {
		alert("Login incorrect...");
        state.status = "error";
		state.site = "";
		
    },
    auth_logout: state => {
        state.sessionid = null;
        state.status = "";
		state.site = "";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};